import { jsxs as T, Fragment as C, jsx as d } from "react/jsx-runtime";
import { useStore as M } from "../../../store/index.mjs";
import B from "../../../ui-kit/theme-button.mjs";
import { useState as n } from "react";
import { offerDefaultErrors as b } from "../../../pages/checkout/constants/default-errors.mjs";
import { BadRequest as k } from "@systemeio/util";
import { mercadoPagoCardBuyOffer as S } from "../api/mercado-pago-api.mjs";
import { MercadoPagoThreeDsModal as x } from "../three-ds/index.mjs";
function F({
  isFetching: l,
  buttonTitle: f,
  buttonDisabled: p,
  setErrors: u,
  setIsFetching: a,
  preSubmit: h,
  handleBadRequest: D
}) {
  const { locale: y } = M(), [P, s] = n(!1), [i, g] = n(), [m, w] = n(), c = (o) => {
    window.location.assign(o);
  };
  return /* @__PURE__ */ T(C, { children: [
    /* @__PURE__ */ d(
      B,
      {
        disabled: p,
        type: "submit",
        onClick: async (o) => {
          o.preventDefault(), a(!0), u(b);
          try {
            const e = h();
            if (!e) return;
            const r = await window.cardPaymentBrickController.getFormData(), t = await S(
              {
                ...e,
                options: {
                  token: r.token,
                  mercadoPagoPaymentMethod: r.payment_method_id,
                  installments: r.installments
                }
              },
              y
            );
            if (t.threeDsInfo) {
              w(t.threeDsInfo), g(t.redirect), s(!0);
              return;
            }
            c(t.redirect);
          } catch (e) {
            if (e instanceof k)
              D(e);
            else
              throw e;
          } finally {
            a(!1);
          }
        },
        isFetching: l,
        children: f
      }
    ),
    m && /* @__PURE__ */ d(
      x,
      {
        opened: P,
        onComplete: () => {
          s(!1), i && c(i);
        },
        threeDsInfo: m
      }
    )
  ] });
}
export {
  F as MercadoPagoCardPaymentButton
};
